(function () {
  const MODAL_ID = 'ThemeModal';
  const CACHE = {};
  const MOBILE_HEADER_CACHE = {};

  // ── History lock ─────────────────────────────────────────────────────────
  // While the modal is open, block any history mutations so the injected
  // product-information element can't rewrite the page URL.
  const _pushState    = history.pushState.bind(history);
  const _replaceState = history.replaceState.bind(history);
  let historyLocked = false;
  let savedUrl = null;

  history.pushState = function (...args) {
    if (!historyLocked) _pushState(...args);
  };
  history.replaceState = function (...args) {
    if (!historyLocked) _replaceState(...args);
  };

  function lockHistory() {
    savedUrl = window.location.href;
    historyLocked = true;
  }
  function unlockHistory() {
    historyLocked = false;
    if (savedUrl && window.location.href !== savedUrl) {
      _replaceState(null, '', savedUrl);
    }
    savedUrl = null;
  }

  const CLOSE_SVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M5.63086 14.3692L10 10L14.3692 14.3692M14.3692 5.63086L9.99919 10L5.63086 5.63086" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ARROW_UP_SVG   = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M4 13L10 7L16 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ARROW_DOWN_SVG = '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M4 7L10 13L16 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const THUMB_HEIGHT = 130;
  const THUMB_GAP    = 6;

  const MODAL_SHELL = `
    <div data-modal-content class="theme-modal-content popup-shadow cross-sell-modal-pdp">
      <button type="button" data-close class="button-unstyled icon-fallback-text standalone-icon--wrapper csm-close" aria-label="Close">
        <span class="fallback-text">Close</span>
        ${CLOSE_SVG}
      </button>
      <div class="csm-layout">
        <div class="csm-col-left">
          <div class="csm-mobile-header"></div>
        </div>
        <div class="csm-col-right">
          <div class="csm-info-scrollable"></div>
          <div class="csm-footer"></div>
        </div>
      </div>
    </div>
  `;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function closeModal() {
    unlockHistory();
    document.body.classList.remove('theme-modal-open');
    document.removeEventListener('keydown', onKeydown);
    const modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-quick-view', 'is-cross-sell');
    setTimeout(() => { modal.innerHTML = ''; }, 600);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function buildThumbNav(colLeft, thumbEls, mainWrap) {
    if (thumbEls.length <= 1) return;

    let offset = 0;

    const wrapper = document.createElement('div');
    wrapper.className = 'csm-thumbs-wrapper';

    const btnUp = document.createElement('button');
    btnUp.type = 'button';
    btnUp.className = 'csm-thumb-arrow csm-thumb-arrow--up is-hidden';
    btnUp.innerHTML = ARROW_UP_SVG;
    btnUp.setAttribute('aria-label', 'Previous images');

    const viewport = document.createElement('div');
    viewport.className = 'csm-gallery-thumbs';

    const track = document.createElement('div');
    track.className = 'csm-thumbs-track';
    thumbEls.forEach((thumb, i) => {
      track.appendChild(thumb);
      thumb.addEventListener('click', () => {
        mainWrap.querySelectorAll('.csm-slide').forEach((s, j) => s.classList.toggle('is-active', j === i));
        track.querySelectorAll('.csm-thumb').forEach((t, j) => t.classList.toggle('is-active', j === i));
      });
    });
    viewport.appendChild(track);

    const btnDown = document.createElement('button');
    btnDown.type = 'button';
    btnDown.className = 'csm-thumb-arrow csm-thumb-arrow--down';
    btnDown.innerHTML = ARROW_DOWN_SVG;
    btnDown.setAttribute('aria-label', 'Next images');

    wrapper.appendChild(btnUp);
    wrapper.appendChild(viewport);
    wrapper.appendChild(btnDown);
    colLeft.insertBefore(wrapper, mainWrap);

    function getThumbH() {
      return thumbEls[0]?.offsetHeight || THUMB_HEIGHT;
    }

    function getVisibleCount() {
      const th = getThumbH();
      return Math.max(1, Math.round(viewport.clientHeight / (th + THUMB_GAP)));
    }

    function updateArrows() {
      const vis = getVisibleCount();
      btnUp.classList.toggle('is-hidden', offset === 0);
      btnDown.classList.toggle('is-hidden', offset + vis >= thumbEls.length);
    }

    function scrollTo(newOffset) {
      offset = newOffset;
      track.style.transform = `translateY(-${offset * (getThumbH() + THUMB_GAP)}px)`;
      updateArrows();
    }

    btnUp.addEventListener('click', () => { if (offset > 0) scrollTo(offset - 1); });
    btnDown.addEventListener('click', () => {
      if (offset + getVisibleCount() < thumbEls.length) scrollTo(offset + 1);
    });

    setTimeout(updateArrows, 50);
  }

  function getVisibleSlideCount() {
    return window.innerWidth <= 600 ? 1 : 2;
  }

  function buildPaginationDots(colLeft, slides, mainWrap) {
    if (slides.length <= 1) return;

    const dots = document.createElement('div');
    dots.className = 'csm-pagination';

    function rebuild() {
      const visible = getVisibleSlideCount();
      const count = Math.max(1, slides.length - visible + 1);
      dots.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('span');
        dot.className = `csm-pagination-dot${i === 0 ? ' is-active' : ''}`;
        dot.addEventListener('click', () => {
          const slide = mainWrap.querySelectorAll('.csm-slide')[i];
          if (slide) mainWrap.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      }
    }

    rebuild();
    colLeft.appendChild(dots);

    let lastVisible = getVisibleSlideCount();
    window.addEventListener('resize', () => {
      const v = getVisibleSlideCount();
      if (v !== lastVisible) { lastVisible = v; rebuild(); }
    });

    // Sync dots on scroll
    let ticking = false;
    mainWrap.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const slideEls = mainWrap.querySelectorAll('.csm-slide');
        const visible = getVisibleSlideCount();
        const maxIdx = Math.max(0, slideEls.length - visible);
        const scrollLeft = mainWrap.scrollLeft;
        const atEnd = scrollLeft + mainWrap.clientWidth >= mainWrap.scrollWidth - 5;
        let activeIdx = 0;
        if (atEnd) {
          activeIdx = maxIdx;
        } else {
          let minDist = Infinity;
          slideEls.forEach((s, j) => {
            if (j > maxIdx) return;
            const dist = Math.abs(s.offsetLeft - scrollLeft);
            if (dist < minDist) { minDist = dist; activeIdx = j; }
          });
        }
        dots.querySelectorAll('.csm-pagination-dot').forEach((d, j) => {
          d.classList.toggle('is-active', j === activeIdx);
        });
        ticking = false;
      });
    });
  }

  function buildGallery(colLeft, card) {
    const tmpl = card.querySelector('template.cross-sell-modal-media');
    if (!tmpl) return;

    const temp = document.createElement('div');
    temp.innerHTML = tmpl.innerHTML;
    // Template images use loading="lazy" but the modal's CSS transform during open
    // prevents IntersectionObserver from firing — force eager so they load immediately.
    temp.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });

    const slides = Array.from(temp.querySelectorAll('.csm-slide'));
    const thumbs = Array.from(temp.querySelectorAll('.csm-thumb'));
    if (!slides.length) return;

    const mainWrap = document.createElement('div');
    mainWrap.className = 'csm-gallery-main';
    slides.forEach(s => mainWrap.appendChild(s));

    colLeft.appendChild(mainWrap);
    buildThumbNav(colLeft, thumbs, mainWrap);
    buildPaginationDots(colLeft, slides, mainWrap);
  }

  function injectMobileHeader(modal, doc, url) {
    const dest = modal.querySelector('.csm-mobile-header');
    if (!dest) return;
    if (doc) {
      const src = doc.querySelector('.pdp-mobile-header');
      if (src) {
        const html = src.innerHTML;
        if (url) MOBILE_HEADER_CACHE[url] = html;
        dest.innerHTML = html;
      }
    } else if (url && MOBILE_HEADER_CACHE[url]) {
      dest.innerHTML = MOBILE_HEADER_CACHE[url];
    }
  }

  // Replace custom elements that update page-level state with inert divs,
  // so their JS never initialises when injected into the modal DOM.
  // product-swatch is also neutralised: its connectedCallback emits variant:change
  // with no sectionId guard in the page's product-media listener, which causes
  // resetSlider() to run and visually update the background gallery.
  const NAV_CUSTOM_ELEMENTS = ['product-information', 'linked-products', 'product-swatch', 'variant-dropdown'];
  function neutraliseCustomElements(html) {
    let result = html;
    NAV_CUSTOM_ELEMENTS.forEach(tag => {
      // Match opening tags with attributes (<tag ...) or no attributes (<tag>)
      const open  = new RegExp(`<${tag}(\\s|>)`, 'gi');
      const close = new RegExp(`</${tag}>`, 'gi');
      result = result.replace(open, `<div data-was="${tag}"$1`).replace(close, '</div>');
    });
    // Namespace radio input names before injection to prevent deselecting background page radios
    result = result.replace(/name="(option-\d+-)/g, 'name="csm-$1');
    return result;
  }

  function cleanProductInfo(scrollable) {
    // Remove cross-sells block (e.g. "Pairs well with") from inside the modal
    scrollable.querySelectorAll('.cross-sell-block').forEach(el => el.remove());

    // Close all open accordions and reset their content height
    scrollable.querySelectorAll('.collapsible-tab.open').forEach(tab => {
      tab.classList.remove('open');
      const content = tab.querySelector('.collapsible-content');
      if (content) {
        content.style.height = '0';
        content.style.overflow = 'hidden';
      }
    });

    // Hide the original add to cart button (we use the proxy in the footer)
    const originalAtc = scrollable.querySelector('[name="add"]');
    if (originalAtc) {
      const btnWrapper = originalAtc.closest('.product-form__buttons') || originalAtc.parentElement;
      if (btnWrapper) btnWrapper.style.display = 'none';
    }
  }

  function getVariantFromInput(scrollable, input) {
    const scriptEl = scrollable.querySelector(
      `script[type="application/json"][data-resource="${input.id}"]`
    );
    if (!scriptEl) return null;
    try { return JSON.parse(scriptEl.textContent) || null; } catch (_) { return null; }
  }

  function getVariantIdFromInput(scrollable, input) {
    return getVariantFromInput(scrollable, input)?.id || null;
  }

  function buildStickyFooter(footer, scrollable, productUrl) {
    // Determine the current variant from whichever radio is checked.
    // We track this ourselves because product-form's constructor runs before its
    // children are attached (innerHTML timing), so its submit handler never fires.
    const getCheckedVariant = () => {
      const checked = scrollable.querySelector('input[data-product-variant]:checked');
      return checked ? getVariantFromInput(scrollable, checked) : null;
    };

    let currentVariant = getCheckedVariant();
    let currentVariantId = currentVariant?.id || null;

    const cartType = document.getElementById('PageContainer')?.dataset.cartType;
    const sections = cartType === 'drawer' ? 'cart-drawer' : null;

    const atcBtn = document.createElement('button');
    atcBtn.type = 'button';
    atcBtn.className = 'btn btn--primary csm-atc-btn';

    function updateAtcBtn(variant) {
      const available = variant?.available ?? true;
      atcBtn.textContent = available ? 'Add to Bag' : 'Sold Out';
      atcBtn.disabled = !available;
      atcBtn.classList.toggle('is-sold-out', !available);
    }

    updateAtcBtn(currentVariant);

    // Keep currentVariantId in sync as the user picks options.
    // For combined-listing color swatches (different product per color), navigate
    // within the modal instead of just updating the variant ID.
    // stopPropagation prevents change events on modal inputs from bubbling to
    // any page-level handlers that might update the background product.
    scrollable.addEventListener('change', function (e) {
      const input = e.target.closest('input[data-product-variant]');
      if (!input) return;
      e.stopPropagation();
      if (input.dataset.isCombinedListing === 'true') {
        const newUrl = input.getAttribute('data-product-url');
        if (newUrl) { loadProductIntoModal(newUrl); return; }
      }
      const variant = getVariantFromInput(scrollable, input);
      if (variant) {
        currentVariantId = variant.id;
        updateAtcBtn(variant);
      }
    });

    atcBtn.addEventListener('click', async () => {
      if (!currentVariantId || atcBtn.classList.contains('is-sold-out')) return;
      atcBtn.disabled = true;

      const body = { id: currentVariantId, quantity: 1 };
      if (sections) body.sections = sections;

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        if (resp.ok) {
          const json = await resp.json();
          window.eventBus?.emit('update:cart:drawer', json);
          window.eventBus?.emit('cart:added', {});
          if (cartType === 'drawer') {
            window.eventBus?.emit('open:cart:drawer', { scrollToTop: true });
          } else {
            window.location = window.routes?.cart_url || '/cart';
          }
        }
      } catch (err) {
        console.error('CSM add to cart error:', err);
      } finally {
        atcBtn.disabled = false;
      }
    });

    const pdpLink = document.createElement('a');
    pdpLink.href = productUrl;
    pdpLink.className = 'csm-pdp-link';
    pdpLink.textContent = 'View Full Details';

    footer.appendChild(atcBtn);
    footer.appendChild(pdpLink);
  }

  async function buildGalleryFromJson(colLeft, handle) {
    try {
      const resp = await fetch(`/products/${handle}.json`);
      if (!resp.ok) return;
      const data = await resp.json();
      const images = data.product.images.slice(0, 20);
      if (!images.length) return;

      const mobileHeader = colLeft.querySelector('.csm-mobile-header');
      colLeft.innerHTML = '';
      if (mobileHeader) colLeft.appendChild(mobileHeader);

      const mainWrap = document.createElement('div');
      mainWrap.className = 'csm-gallery-main';

      const thumbEls = [];

      images.forEach((img, i) => {
        const slide = document.createElement('div');
        slide.className = `csm-slide${i === 0 ? ' is-active' : ''}`;
        const image = document.createElement('img');
        image.src = img.src;
        image.alt = img.alt || data.product.title;
        image.loading = 'eager';
        slide.appendChild(image);
        mainWrap.appendChild(slide);

        const thumb = document.createElement('button');
        thumb.className = `csm-thumb${i === 0 ? ' is-active' : ''}`;
        thumb.dataset.slide = i;
        thumb.type = 'button';
        const tImg = document.createElement('img');
        tImg.src = img.src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_300x$1$3');
        tImg.alt = img.alt || '';
        tImg.loading = 'eager';
        thumb.appendChild(tImg);
        thumbEls.push(thumb);
      });

      colLeft.appendChild(mainWrap);
      buildThumbNav(colLeft, thumbEls, mainWrap);
      buildPaginationDots(colLeft, images, mainWrap);
    } catch (err) {
      console.error('Cross-sell gallery error:', err);
    }
  }

  async function loadProductIntoModal(productUrl) {
    const modal = getModal();
    if (!modal) return;

    const scrollable = modal.querySelector('.csm-info-scrollable');
    const footer = modal.querySelector('.csm-footer');
    const colLeft = modal.querySelector('.csm-col-left');
    if (!scrollable || !footer) return;

    const cleanUrl = productUrl.split('?')[0];
    const handle = cleanUrl.split('/products/')[1];

    // Save both linked product elements and pre-apply the new active state
    const savedLinkedProducts = scrollable.querySelector('[data-was="linked-products"]')?.cloneNode(true);
    const savedColorSwatch = scrollable.querySelector('.pdp-linked-products-swatch')?.cloneNode(true);

    if (savedLinkedProducts && handle) {
      savedLinkedProducts.querySelectorAll('.swatch-element').forEach(el => {
        const link = el.querySelector('a');
        const linkHandle = link?.getAttribute('href')?.split('/products/')[1]?.split('?')[0];
        el.classList.toggle('active', linkHandle === handle);
      });
    }

    if (savedColorSwatch) {
      savedColorSwatch.querySelectorAll('.swatch-element').forEach(el => {
        const link = el.querySelector('a.pdp-linked-swatch__link');
        if (!link) return;
        const isActive = link.getAttribute('href')?.split('?')[0] === cleanUrl;
        el.classList.toggle('active', isActive);
        if (isActive) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    scrollable.innerHTML = '<div class="csm-loading">Loading&hellip;</div>';
    footer.innerHTML = '';

    // Update gallery in parallel
    if (handle && colLeft) buildGalleryFromJson(colLeft, handle);

    // Swap both linked product elements into content fragment before setting innerHTML
    // so the original order never flashes
    function applyContent(htmlContent) {
      const temp = document.createElement('div');
      temp.innerHTML = htmlContent;

      if (savedLinkedProducts) {
        const lp = temp.querySelector('[data-was="linked-products"]');
        if (lp) lp.replaceWith(savedLinkedProducts.cloneNode(true));
      }

      if (savedColorSwatch) {
        const cs = temp.querySelector('.pdp-linked-products-swatch');
        if (cs) cs.replaceWith(savedColorSwatch.cloneNode(true));
      }

      scrollable.innerHTML = temp.innerHTML;
      cleanProductInfo(scrollable);
      buildStickyFooter(footer, scrollable, cleanUrl);
    }

    if (CACHE[cleanUrl]) {
      applyContent(CACHE[cleanUrl]);
      injectMobileHeader(modal, null, cleanUrl);
      return;
    }

    try {
      const resp = await fetch(cleanUrl);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const text = await resp.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const productInfo = doc.querySelector('product-information');
      const content = neutraliseCustomElements(productInfo ? productInfo.outerHTML : '');
      CACHE[cleanUrl] = content;
      applyContent(content);
      injectMobileHeader(modal, doc, cleanUrl);
    } catch (err) {
      console.error('Cross-sell modal linked product error:', err);
      scrollable.innerHTML = '<p style="padding:1rem">Sorry, could not load product details.</p>';
    }
  }

  async function openModal(card) {
    const modal = getModal();
    if (!modal) return;

    const productUrl = card.querySelector('[data-cross-sell-btn]')?.dataset.productUrl;
    if (!productUrl) return;

    modal.innerHTML = MODAL_SHELL;
    modal.classList.add('is-quick-view', 'is-cross-sell');
    lockHistory();
    document.body.classList.add('theme-modal-open');

    const closeBtn = modal.querySelector('[data-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', onKeydown);

    const colLeft = modal.querySelector('.csm-col-left');
    const scrollable = modal.querySelector('.csm-info-scrollable');
    const footer = modal.querySelector('.csm-footer');

    buildGallery(colLeft, card);

    if (CACHE[productUrl]) {
      scrollable.innerHTML = CACHE[productUrl];
      cleanProductInfo(scrollable);
      buildStickyFooter(footer, scrollable, productUrl);
      injectMobileHeader(modal, null, productUrl);
      return;
    }

    scrollable.innerHTML = '<div class="csm-loading">Loading&hellip;</div>';

    try {
      const resp = await fetch(productUrl);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const text = await resp.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const productInfo = doc.querySelector('product-information');
      // Neutralise ALL custom elements (including product-swatch) so none of their
      // JS initialises in the modal and emits events that affect the background page.
      const content = neutraliseCustomElements(productInfo ? productInfo.outerHTML : '');
      CACHE[productUrl] = content;
      scrollable.innerHTML = content;
      cleanProductInfo(scrollable);
      buildStickyFooter(footer, scrollable, productUrl);
      injectMobileHeader(modal, doc, productUrl);

    } catch (err) {
      console.error('Cross-sell modal error:', err);
      scrollable.innerHTML = '<p style="padding:1rem">Sorry, could not load product details.</p>';
    }
  }

  document.addEventListener('click', function (e) {
    // Any product link inside the modal scrollable — update modal instead of navigating.
    // stopImmediatePropagation prevents pdp-linked-swatches.js (also on document) from
    // seeing this click and running swapSections on the background page.
    const modalLink = e.target.closest('.csm-info-scrollable a[href]');
    if (modalLink) {
      const href = modalLink.getAttribute('href')?.split('?')[0];
      if (href && href.includes('/products/')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        loadProductIntoModal(href);
        return;
      }
    }

    // Cross-sell image link or + button — open modal
    const trigger = e.target.closest('.cross-sell-card__image-link, [data-cross-sell-btn]');
    if (!trigger) return;
    e.preventDefault();
    const card = trigger.closest('.cross-sell-card');
    if (card) openModal(card);
  });
})();
